/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'logout': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 49.89',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path pid="0" class="cls-1" d="M35.27 46.52A23.5 23.5 0 0 1 10.54 6.63M37.44 6.61a23.52 23.52 0 0 1 7.39 30.19M24 0v27.33"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/logout.js